import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft, Building2 } from "lucide-react";

// Croatian-only Thank You page (no language switching, no header/footer)
export default function ThankYou() {
  return (
    <main className="min-h-screen flex items-center justify-center" style={{ background: "var(--z-bg)" }}>
      <div className="z-container max-w-[720px] py-20 text-center flex flex-col items-center">
        <Link to="/" className="inline-flex items-center gap-2 mb-10" aria-label="Zynteroq">
          <span aria-hidden className="inline-flex items-center justify-center w-10 h-10 rounded-xl" style={{ background: "linear-gradient(135deg,#0F3B36,#0B6B5A)" }}>
            <Building2 size={20} color="#E7C989" />
          </span>
          <span className="font-display text-[26px]">Zynteroq</span>
        </Link>

        <div className="flex items-center justify-center w-16 h-16 rounded-full mb-6" style={{ background: "rgba(15,59,54,0.10)", color: "var(--z-brand)" }}>
          <CheckCircle2 size={30}/>
        </div>

        <h1 className="font-display text-[40px] md:text-[54px] leading-[1.05]" data-testid="thankyou-title">
          Hvala vam na povjerenju
        </h1>
        <p className="mt-5 text-[16px] md:text-[17px] text-[color:var(--z-ink-2)] max-w-[560px] mx-auto">
          Vaša poruka je uspješno zaprimljena. Naš savjetnik javit će vam se najkasnije u roku od jednog radnog dana, s Zagreba ili Splita, ovisno o dostupnosti tima.
        </p>
        <p className="mt-3 text-[15px] text-[color:var(--z-muted)] max-w-[520px] mx-auto">
          U međuvremenu, pogledajte kako radi naša platforma ili se vratite na početnu stranicu.
        </p>

        <Link to="/" className="z-btn z-btn-primary mt-10" data-testid="thankyou-back-home">
          <ArrowLeft size={16}/> Povratak na početnu
        </Link>
      </div>
    </main>
  );
}
